import './SearchInput.css'

export interface SearchInputProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  /** Nom accessible du champ (« Rechercher une famille ») : un placeholder
   * seul disparaît à la saisie et n'est pas un libellé. */
  label?: string
}

export function SearchInput({ value, onChange, placeholder, label }: SearchInputProps) {
  return (
    <div className="azoya-search-input">
      <svg
        className="azoya-search-input-icon"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        aria-hidden="true"
      >
        <circle cx="11" cy="11" r="7"></circle>
        <path d="M21 21l-4.3-4.3"></path>
      </svg>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={label}
      />
      {value && (
        <button
          type="button"
          className="azoya-search-input-clear"
          onClick={() => onChange('')}
          aria-label="Effacer"
        >
          ✕
        </button>
      )}
    </div>
  )
}
